import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, Navigate} from "react-router-dom";
import firebase from '../../config/firebase';
import DataClientTable from "../../components/Data-client-table/data-client-table";
import { Button } from "antd";
import AddIcon from '@mui/icons-material/Add';
import './client.css';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
require('firebase/auth')

function ClientList(){
    const db = firebase.firestore();

    const [listClient, setListClient] = useState([]);
    const [carregando, setCarregando] = useState(1);

    let clientList = [];

    var userLogado = useSelector(state => state.usuarioLogado);
    const user = useSelector(state => state.user)

    useEffect(() => {

        if(userLogado > 0) {
            return
        }
        else {
            <Navigate to='/login' />
        }
    },[carregando]);

    return(
        <>
            { 
                useSelector(state => state.usuarioLogado) > 0 ? 
                    <NewMiniDrawer divOpen={
                        <div className="freight-content">
                            <div className="container mb-3">
                                <div className="row">
                                    <div className="col-5">
                                        <h4>Clientes</h4>
                                    </div>
                                    <div className="col-5">
                                    </div>
                                    <div className="col-2">
                                        <div className="col-md-11 control-label">
                                            {
                                                user?.permissoes?.cliente?.cadastrar || user?.permissoes?.client?.isCreate ? (
                                                    <Link to={"/client"}>
                                                        <Button id="ButtonHover" type="primary" icon={<AddIcon />}>
                                                            Novo
                                                        </Button>
                                                    </Link>
                                                )
                                                : (
                                                ""
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>        
                            </div>
                            <div>
                                <div style={{ height: 400, width: '100%' }}>
                                    <DataClientTable />
                                </div>
                            </div>
                        </div>
                }/>
                : 
                <Navigate to='/login' />
            }
        </>
    );
}

export default ClientList;